export default __webpack_public_path__ + "static/media/PhosphorusDiag.bb6c96ab.png";